import { create } from 'zustand';

export enum ATTENDANCE_TYPE {
  PRESENTIAL = 1,
  TELEMEDICINE = 2,
  DEFAULT = 0
}

interface IStore {
  selectedAttendance: number;
  setSelectedAttendance: (prop: number) => void;
  isFirstAppointment: boolean;
  setIsFirstAppointment: (prop: boolean) => void;
}

export const useAttendance = create<IStore>(set => ({
  selectedAttendance: 0,
  setSelectedAttendance: selectedAttendance => set(() => ({ selectedAttendance })),
  isFirstAppointment: false,
  setIsFirstAppointment: isFirstAppointment => set(() => ({ isFirstAppointment }))
}));
